// extracted by mini-css-extract-plugin
export default {"button--custom-color":"LinkShareButton_button--custom-color__4n5cf"};